// #region imports

// --- Angular
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';

// --- HS Code
import { AddJournalEntryForm, JournalQuadrantModel } from '../../models';

// #endregion

@Component({
  selector: 'hs-add-journal',
  templateUrl: './add-journal.component.html',
  styleUrls: ['./add-journal.component.scss']
})
export class AddJournalComponent implements OnChanges {

  @Input() entryText: string = '';
  @Input() style: string = '';
  @Input() quadrants: JournalQuadrantModel[] | null = null;

  @Output() entrySubmit = new EventEmitter<AddJournalEntryForm>();

  @ViewChild('form') form: NgForm | undefined;
  @ViewChild('entryText') entryTextRef: ElementRef | undefined;

  entryForm: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
    this.entryForm = this.fb.group({
      entryText: ['', Validators.required],
      style: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entryText'] && changes['entryText'].currentValue) {
      this._updateEntryText(changes['entryText'].currentValue);
    }
    if (changes && changes['style'] && changes['style'].currentValue) {
      this.entryTextRef?.nativeElement.focus();
      this._updateStyle(changes['style'].currentValue);
    }
  }

  onEntrySubmit() {
    if (this.entryForm.invalid) {
      return;
    }
    this.entrySubmit.emit(this.entryForm.value);
    this.entryForm.reset();
    this.entryForm.markAsPristine();
    this.entryForm.markAsUntouched();
    this.entryForm.updateValueAndValidity();
    this.form?.resetForm();
  }

  private _updateEntryText(entryText: string) {
    this.entryForm.get('entryText')?.setValue(entryText);
  }

  private _updateStyle(style: string) {
    this.entryForm.get('style')?.setValue(style);
  }
}
